import React, { useEffect, useState } from 'react';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import {
  additionalCostData,
  mainBlueColor,
  workingBudgetData
} from '../../GlobalState';
import { AdditionalCostTableItemRow } from './AdditionalCostTableItemRow';
import {
  LOCAL_WORKING_BUDGET_KEY,
  LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY
} from '../../const/Const';
import { useParams } from 'react-router-dom';
import _ from 'lodash';

type TProps = {
  isDetailShow: boolean;
  selectItems: number[];
  setSelectItems: any;
  changeLoggedInData: any;
  setErrorMessage: any;
  setOpen: any;
  workingBudgetId: number;
  reflectData: boolean;
};

/**
 * テーブルヘッダー
 * @constructor
 */
export const AdditionalCostItemTableBody: React.FC<TProps> = (
  props: TProps
) => {
  const {
    isDetailShow,
    selectItems,
    setSelectItems,
    changeLoggedInData,
    setErrorMessage,
    setOpen,
    workingBudgetId,
    reflectData
  } = props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const classes = useStyles({ mainColor: mainColor });
  const [additionalCost, setAdditionalCost] =
    useRecoilState(additionalCostData);
  const params: any = useParams();

  const setKey = params.id
    ? LOCAL_WORKING_BUDGET_KEY + params.id
    : LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY + workingBudgetId;

  useEffect(() => {
    if (reflectData) {
      // ローカルストレージデータを取得
      const localStorageData = localStorage.getItem(setKey);

      if (localStorageData) {
        // ローカルストレージから取得したデータが存在する場合
        const parsedData = JSON.parse(localStorageData);
        const additionalCost = parsedData.additionalCost;
        // additionalCostを更新
        setAdditionalCost(additionalCost);
      }
    }
  }, [reflectData]);

  return (
    <>
      {additionalCost &&
        additionalCost.length > 0 &&
        additionalCost.map((data, index) => (
          <AdditionalCostTableItemRow
            isDetailShow={isDetailShow}
            data={data}
            indent={0}
            changeLoggedInData={changeLoggedInData}
            setErrorMessage={setErrorMessage}
            setOpen={setOpen}
            selectItems={selectItems}
            setSelectItems={setSelectItems}
            key={index}
            workingBudgetId={workingBudgetId}
            reflectData={reflectData}
          />
        ))}
    </>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({})
);
